<div class="wrapper__contentComponent--expediente container my-5">
  <!-- Main panel -->
  <ng-container *ngIf="listFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Lista de tipos de agentes</h2>
      <button
        id="crearAgente"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="crearAgente()">
        <span class="govco-svg govco-plus-circle me-2"></span>
        Crear un tipo de agente
      </button>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <p class="justify-text">
        En el contexto de la Inteligencia Artificial, un agente cognitivo
        racional es un sistema que percibe su entorno, razona sobre la
        información que recibe y toma decisiones de manera óptima para alcanzar
        un objetivo.
      </p>
    </div>
    <div class="d-flex justify-content-end mb-3">
      <div class="input-group w-50">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre"
          [(ngModel)]="searchTerm" />
        <span class="input-group-text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16">
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85a1.007 1.007 0 0 0-.115-.098zm-5.442 1.398a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z" />
          </svg>
        </span>
      </div>
    </div>
    <!-- Tabla de agentes -->
    <div class="table-container" *ngIf="agentes.length > 0; else noData">
      <table class="table table-striped table-bordered">
        <thead class="custom-header">
          <tr>
            <th>Nombre</th>
            <th class="display-none">Estado</th>
            <th class="display-none">Fecha Modificación</th>
            <th class="display-none">Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let agente of agentes
                | filter: searchTerm : 'Nombre'
                | paginate: { itemsPerPage: 5, currentPage: currentPage }
            "
            class="hover-effect">
            <td>{{ agente.Nombre }}</td>
            <td class="display-none">{{ agente.Estado }}</td>
            <td class="display-none">
              {{ agente.FechaModificacion | date: 'yyyy-MM-dd HH:mm' }}
            </td>
            <td class="display-none">{{ agente.UsuarioModificacion }}</td>
            <td class="btns-box">
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="onRowClick(agente)">
                Ver
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="editarAgente(agente)">
                Editar
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="eliminarAgente(agente.Id)">
                Eliminar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination Controls -->
      <pagination-controls
        (pageChange)="currentPage = $event"
        previousLabel="Anterior"
        nextLabel="Siguiente"
        class="d-flex justify-content-center mt-3">
      </pagination-controls>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noData>
      <div class="no-data-container">
        <p>{{ mensaje }}</p>
      </div>
    </ng-template>
  </ng-container>
  <!-- Read panel -->
  <ng-container *ngIf="readFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Formulario de tipo de agente</h2>
      <button
        id="detalleAgente"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="volverElemento()">
        <span class="govco-svg govco-arrow-circle-left me-2"></span>
        Volver a elemento
      </button>
    </div>
    <form [formGroup]="agenteForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div *ngFor="let field of nomDesForm" class="col-md-{{ field.width }}">
          <div class="mb-3">
            <label [for]="field.name" class="form-label"
              >{{ field.label
              }}<span
                *ngIf="field.required"
                _ngcontent-ng-c3465959523=""
                class="text-danger">
                *</span
              ></label
            >
            <!-- Text Input -->
            <input
              *ngIf="field.type === 'text'"
              [id]="field.name"
              [type]="field.type"
              class="form-control"
              [formControlName]="field.name"
              [readonly]="isReadOnly" />
            <!-- Textarea -->
            <textarea
              *ngIf="field.type === 'textarea'"
              [id]="field.name"
              class="form-control"
              [formControlName]="field.name"
              rows="3"
              [readonly]="isReadOnly"></textarea>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select1'"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option *ngFor="let option of estados" [value]="option">
                {{ option }}
              </option>
            </select>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select2'"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option *ngFor="let opt of roles" [value]="opt.Id">
                {{ opt.Nombre }}
              </option>
            </select>

            <!-- Text Input -->
            <input
              *ngIf="field.type === 'number'"
              [id]="field.name"
              [type]="field.type"
              class="form-control"
              [formControlName]="field.name"
              [readonly]="isReadOnly" />
            <!-- Validation Error Messages -->
            <div *ngIf="getErrorMessage(field.name)" class="text-danger">
              {{ getErrorMessage(field.name) }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 d-flex gap-2">
        <button
          type="button"
          class="btn-govco fill-btn-govco"
          (click)="toggleEdit()"
          *ngIf="isReadOnly">
          Editar
        </button>
        <button
          type="submit"
          class="btn-govco fill-btn-govco"
          *ngIf="!isReadOnly">
          Guardar
        </button>
        <button
          type="button"
          class="btn-govco btn-govco"
          (click)="toggleEdit()"
          *ngIf="!isReadOnly">
          Cancelar
        </button>
      </div>
    </form>
  </ng-container>
</div>
<div *ngIf="modalNDFlag">
  <app-modal-nom-des [elements]="agentes" (ndEmitter)="registrarAgente($event)">
  </app-modal-nom-des>
</div>
